// src/lib/build-version.js
// 2026-05-29 EXTRACTED from src/App.jsx (C1 refactor) as a behavior-preserving
// TRANSFORM. These are the "did a new build deploy? -> reload" version consts —
// the build-hash reload-check cluster. They are a DIFFERENT concern from the
// per-table data-version map in ./data-versions.js (that one drives the
// save/sync optimistic-concurrency 409 flow; this one compares the app
// VERSION / bundle hash to detect a fresh deploy).
//
// Why extract:
//   - connectWebSocket (still in App.jsx, extracted next) reads INITIAL_BUILD_HASH
//     for the WS-heartbeat handshake version check (msg.bh !== INITIAL_BUILD_HASH
//     => "server build != client build" => auto-reload). Hoisting it into a tiny
//     leaf module lets the network layer import the SAME value WITHOUT importing
//     App.jsx — avoids an import cycle (App.jsx -> network layer -> App.jsx).
//   - Same precedent as src/lib/connection-state.js, src/lib/data-versions.js,
//     src/lib/local-storage.js.
//
// What stays in App.jsx: the version-upgrade SIDE-EFFECT block
// (`if (prevVersion !== VERSION) { ... removeItem(LS_VERSIONS_KEY) ... }`) runs
// once at App.jsx module-init time. It is intentionally LEFT in App.jsx so its
// init ordering relative to the rest of the import graph (notably
// ./data-versions.js's loadPersistedVersions, which reads LS_VERSIONS_KEY) is
// unchanged. App.jsx imports PREV_VERSION_KEY + prevVersion back for that block.
//
// No imports needed: INITIAL_BUILD_HASH uses `document` (global), prevVersion
// uses `localStorage` (global), PREV_VERSION_KEY is a string literal. Imports
// NOTHING from App.jsx — no cycle.

// Build hash — extracted from currently-loaded main bundle <script src="/assets/index-XXX.js">.
// Compared against server's BUILD_HASH в WS heartbeat (msg.bh) — closes auto-reload
// gap when VERSION doesn't bump (structural deploys like Phase 17 cleanup, refactors).
// Read once at module init; new deploy = new bundle hash = new script tag = mismatch.
export const INITIAL_BUILD_HASH = (() => {
  if (typeof document === 'undefined') return null;
  const script = document.querySelector('script[src*="/assets/index-"]');
  if (!script) return null;
  const m = script.src.match(/\/assets\/index-([A-Za-z0-9_-]+)\.js/);
  return m ? m[1] : null;
})();

// ── Version change detection keys (used by the version-upgrade block in App.jsx) ──
export const PREV_VERSION_KEY = 'blitz_app_version';
export const prevVersion = localStorage.getItem(PREV_VERSION_KEY);
